<form [formGroup]="_form" #formDirective="ngForm" (ngSubmit)="createFolder(formDirective)">

  <!--title-->
  <h2 mat-dialog-title>
    <i class="material-icons m-r-10">folder_open</i>
    <span>{{'Modules.FileManager.Applications.FileManager.Folders.CreateModal.Title' | translate}}</span>
  </h2>

  <!--content-->
  <mat-dialog-content>

    <mat-form-field floatPlaceholder="auto" class="float-auto">
      <input #createFolderInput matInput placeholder="{{'Modules.FileManager.Applications.FileManager.Folders.CreateModal.Form.Name' | translate}}" formControlName="name">
      @if (name.errors?.required && name.touched) {
        <mat-error>
          {{'Commons.Validation.Required' | translate : { field: "" | translate } }}
        </mat-error>
      }
    </mat-form-field>

  </mat-dialog-content>

  <!--actions-->
  <mat-dialog-actions>
    <button type="submit" mat-flat-button mat-ripple color="accent" [class.disabled]="!_form.valid">
      {{ 'Commons.Actions.Confirm' | translate }}
    </button>
    <button type="button" mat-button mat-ripple mat-dialog-close>
      {{'Commons.Actions.Cancel' | translate}}
    </button>
  </mat-dialog-actions>

</form>